import colors from "./Colors"

module.exports = { colors }



// WEBPACK FOOTER //
// ./src/data/Color.js